/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Mellow_Racoon_DustInputs */

const fr_agent_mellow_racoon_dust = /** @type {(inputs: Agent_Mellow_Racoon_DustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression de l'utilisateur`)
};

/**

* @param {Agent_Mellow_Racoon_DustInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const agent_mellow_racoon_dust = /** @type {((inputs?: Agent_Mellow_Racoon_DustInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Mellow_Racoon_DustInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_agent_mellow_racoon_dust(inputs)
});